<template>
  <div>
    <div class="top-img" :class="{ 'image-loaded': imageLoaded }">
      <img loading="lazy" :src="experiencesImage" class="top-bg" @load="onImageLoad"/>
    </div>
    <div class="categories">
      <div class="container">
        <div class="col-12">
          <div v-if="showCategories" id="swiper-categories" class="swiper-container">
            <div class="swiper-wrapper">
              <div class="tab" :class="{ active: activeType == type.value }" v-for="type in types" :key="type.value">
                <h4 class="category" @click="initializePage(activeType = type.value)">
                  {{ type.category }}
                </h4>
              </div>
            </div>
          </div>
          <LogoLoading v-if="!experiences" />
          <div v-else class="experiences-list">
            <div class="container">
              <template v-if="experiences.length">
                <div class="experiences-grid">
                    <div 
                      class="experience-item" 
                    v-for="(experience, index) in experiences" 
                      :key="experience.id"
                    @click="experienceDetail(index)"
                    >
                      <ExperienceThumb class="card-experience" :experienceContent="experience" />
                    </div>
                </div>
              </template>
              <template v-else>
                <NoResultsPlaceholder />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import InputGetList from "@/classes/InputGetList";
import { API_HELPER } from "@/helpers/api.js";
import LogoLoading from "@/components/LogoLoading.vue"
import NoResultsPlaceholder from "@/components/NoResultsPlaceholder.vue"
import ExperienceThumb from '@/components/HomePage/experiences/ExperienceThumb.vue';

export default {
  props: {
    showCategories: {
      type: Boolean,
      default: true
    }
  },
  metaInfo() {
    return {
      title: this.$t("vueRoutes.experiencesTitle"),
      titleTemplate: '%s - Quinta Do Barbusano',
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      meta:
        [
          { name: 'description', content: this.$t("vueRoutes.experiencesDescription") },
          { name: 'keywords', content: this.experiences && this.experiences.length ? this.experiences.map(x => x.name).join(", ") : this.$t("vueRoutes.experiencesKeywords") },
        ],
      link: [
        { rel: 'alternate', hreflang: 'pt', href: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.$t("vueRoutes.experiences", 'pt')]) },
        { rel: 'alternate', hreflang: 'en', href: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.$t("vueRoutes.experiences", 'en')]) },
      ]
    }
  },
  components: {
    LogoLoading,
    NoResultsPlaceholder,
    ExperienceThumb
  },
  data() {
    return {
      types: [
        { category: this.$t("type.all"), value: null }, 
        { category: this.$t("type.featured"), value: true }
      ],
      activeType: null,
      imageLoaded: false
    };
  },
  mounted() {
    this.initializePage(this.activeType);
    this.initializeHero();
  },
  computed: {
    ...mapState({
      experiencesOutput: state => state.experiences.listOutput,
      herosOutput: state => state.heros.listOutput,
    }),
    experiences() {
      console.log(this.experiencesOutput);
      return this.experiencesOutput && this.experiencesOutput.data ? this.experiencesOutput.data : null;
    },
    experiencesImage() {
      let result = null;
      if (this.herosOutput && this.herosOutput.data && this.herosOutput.data.heroItems && this.herosOutput.data.heroItems.length) {
        const item = this.herosOutput.data.heroItems.find(obj => obj.types && obj.types.some(typeObj => typeObj.type === 'Experiences'));
        result = item && item.image ? API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, item.image]) : null;
      }
      return result;
    }
  },
  methods: {
    ...mapActions({
      getExperiences: 'experiences/getList',
      getHeros: 'heros/getList',
    }),
    setExperiencesPerView() {
      const width = window.innerWidth || document.documentElement.clientWidth;
      let perView = 3;
      if (width < 768) {
        perView = 1;
      } else if (width < 1200) {
        perView = 2;
      }
      if (perView !== this.experiencesPerView) {
        this.experiencesPerView = perView;
        // clamp currentSlide to valid range when perView changes
        const max = this.maxSlide;
        if (this.currentSlide > max) {
          this.currentSlide = max;
        }
      }
    },
    experienceDetail(index) {
      this.$router.push({ name: 'ExperienceDetail', params: { experience: this.experiences[index], experienceSlug: this.experiences[index].slug } });
    },
    joinPaths(relativePath) {
      return API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, relativePath]);
    },
    initializePage(activeType) {
      // GET list of experiences
      const itemsPerPage = 999;
      const currentPage = 1;
      const sorter = 1; // asc
      const propertyName = "position";
      const searchText = '';
      var input = new InputGetList(itemsPerPage, currentPage, sorter, propertyName, searchText);
      input.isFeatured = activeType
      this.getExperiences(input);
    },
    initializeHero() {
      const itemsPerPage = 99;
      const currentPage = 1;
      const sorter = 1; // asc
      const propertyName = "id";
      const searchText = '';
      var input = new InputGetList(itemsPerPage, currentPage, sorter, propertyName, searchText);
      input.visible = true;
      this.getHeros(input);
    },
    onImageLoad() {
      this.imageLoaded = true;
    }
  }
};
</script>

<style scoped>
.top-img {
  position: relative;
  width: 100%;
  height: clamp(240px, 45vh, 465px);
}

.top-img .top-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.top-img::before {
  content: "";
  width: 100%;
  height: 80%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(180deg, #000, rgba(84, 84, 84, 0));
  mix-blend-mode: multiply;
  opacity: 0;
  z-index: 4;
  transition: opacity 0.5s ease;
}

.top-img.image-loaded::before {
  opacity: 0.45;
}

.categories {
  padding-top: 6rem;
  padding-bottom: 80px;
  display: flex;
  justify-content: center;
}

.categories .container {
  display: flex;
  justify-content: center;
}

.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  width: 100%;
}

.categories .swiper-wrapper {
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 10;
  margin-right: 0;
  margin-top: -10px;
  width: auto;
}

.tab {
  cursor: pointer;
  opacity: 0.3;
}

.active {
  color: var(--primary-color);
  opacity: 1;
}

.categories .tab {
  width: auto;
}

.tab {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
}

.categories .category,
.categories .year {
  display: inline-block;
  font-size: 16px;
  line-height: 23px;
  padding: 11px 32px;
  text-transform: uppercase;
  white-space: nowrap;
  color: inherit;
  text-decoration: none;
  font-weight: bold;
}

.categories .category:hover {
  opacity: 1;
  color: var(--primary-color);
}

.card-experience {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0;
  max-width: 100%;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0;
  height: 100%;
}

.card-experience:hover {
  transform: scale(1.1);
}

:deep(.card-experience img) {
  max-height: 280px;
  height: 280px;
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  transition: all .4s ease-in-out;
  border-radius: 8px;
  object-fit: cover;
  display: block;
}

.clean-link {
  color: inherit;
  text-decoration: none;
}

:deep(.card-experience .name) {
  font-size: 22px;
  line-height: 28px;
  max-width: 270px;
  color: var(--primary-color);
  margin-bottom: 10px;
  text-align: center;
}

:deep(.card-experience .category) {
  color: var(--secondary-color);
  font-size: 13px;
  line-height: 24px;
  text-align: center;
  max-width: 270px;
}

@media screen and (max-width: 991px) {
  .categories .swiper-wrapper {
    display: flex;
    justify-content: center;
    margin-right: 0;
    margin-top: 0;
  }
}

:deep(.vueperslide__content-wrapper:not(.vueperslide__content-wrapper--outside-top):not(.vueperslide__content-wrapper--outside-bottom)) {
  height: unset !important;
}

/* Experiences Grid Styles */
.experiences-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 2rem;
  padding: 0 20px;
  justify-items: center;
  max-width: 100%;
}

.experience-item {
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: center;
}

@media screen and (min-width: 769px) and (max-width: 1200px) {
  /* Center tabs for tablets */
  .categories .swiper-wrapper {
    display: flex !important;
    justify-content: center !important;
    margin-right: 0 !important;
    margin-top: 0 !important;
  }
  
  .swiper-container {
    display: flex;
    justify-content: center;
  }
  
  /* Grid for tablets - show 2 experiences per row */
  .experiences-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    justify-items: center;
  }
}

/* Desktop - show 3 experiences per row */
@media screen and (min-width: 1201px) {
  .experiences-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    justify-items: center;
  }
}

@media screen and (max-width: 768px) {
  /* Center tabs */
  .categories .swiper-wrapper {
    display: flex !important;
    justify-content: center !important;
    margin-right: 0 !important;
    margin-top: 0 !important;
  }
  
  .swiper-container {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  
  /* Grid for mobile - show 1 experience per row */
  .experiences-grid {
    grid-template-columns: 1fr;
    gap: 30px;
    padding: 0 20px;
    justify-items: center;
  }
  
  /* Ensure card is centered on mobile */
  .card-experience {
    margin-left: auto !important;
    margin-right: auto !important;
    width: 100%;
    max-width: 85%;
  }
  
  /* Smaller image on small screens - fixed size */
  ::deep(.card-experience img) {
    height: 220px;
    max-height: 220px;
    width: 100%;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    object-fit: cover;
  }
  
  /* Make image container smaller */
  ::deep(.image-container) {
    max-width: 100%;
    height: 220px !important;
  }
}

@media screen and (max-width: 480px) {
  .experiences-grid {
    padding: 0 10px;
  }
  
  .card-experience {
    max-width: 80%;
  }
  
  ::deep(.card-experience img) {
    height: 200px;
    max-height: 200px;
  }
  
  ::deep(.image-container) {
    height: 200px !important;
  }
}

.experience-item {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
</style>

